import { EventBus } from './EventBus';

/**
 * When the ApolloClient finds an error,
 * this EventBus will be utilized and
 * emitting that info for the UI.
 */
export const GqlErrorBus = new EventBus('gql-error-bus');
